import React, { useEffect, useState } from "react"
import { currency } from "../../../constants/constants"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardText,
  CardHeader,
  Collapse,
} from "reactstrap"

export default function PragmaticData(props) {
  const [ispragmaticOpen, setispragmaticOpen] = useState(false)
  const [pragmatic, setpragmatic] = useState([])
  const pragmatictoggle = () => setispragmaticOpen(!ispragmaticOpen)
  const cardstyle = {
    height: "130px",
    borderRadius: "15px",
  }
  const currencyStyle = {
    fontSize: "12px",
  }
  const cardHeader = {
    height: "60px",
  }
  useEffect(() => {
    if (props.data) {
      setpragmatic(props.data)
    }
  }, [props.data])
  const formatAmount = amount => {
    const roundedAmount = parseFloat(amount).toFixed(2) // Round to 2 decimal places
    return new Intl.NumberFormat().format(roundedAmount) // Format the rounded amount
  }
  return (
    pragmatic.length !== 0 && (
      <Card style={{ backgroundColor: "#E8E8E8" }}>
        <CardHeader
          onClick={pragmatictoggle}
          style={{ cursor: "pointer", backgroundColor: "#E8E8E8" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "20px",
            }}
          >
            Pragmatic Play{" "}
            {ispragmaticOpen ? (
              <i className="fa fa-fw fa-angle-up" />
            ) : (
              <i className="fa fa-fw fa-angle-down" />
            )}
          </div>
        </CardHeader>
        <Collapse isOpen={ispragmaticOpen}>
          <CardBody>
            <Row>
              <Col lg={2} className="m-2">
                <Card
                  className="border-2 border-success text-success"
                  style={cardstyle}
                >
                  <CardHeader
                    className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                    style={cardHeader}
                  >
                    Total Bets Count
                  </CardHeader>
                  <CardBody>
                    <CardText className="font-size-16 font-weight-semibold">
                      {pragmatic.total_bet_count.toLocaleString()}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={2} className="m-2">
                <Card
                  className="border-2 border-info text-info"
                  style={cardstyle}
                >
                  <CardHeader
                    className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                    style={cardHeader}
                  >
                    Total Bets Amount
                  </CardHeader>
                  <CardBody>
                    <CardText className="font-size-16 font-weight-semibold">
                      {formatAmount(pragmatic.total_bet_amount)}
                      <span style={currencyStyle}> {currency}</span>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={2} className="m-2">
                <Card
                  className="border-2 border-danger text-danger"
                  style={cardstyle}
                >
                  <CardHeader
                    className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                    style={cardHeader}
                  >
                    Total Bets Winning Count
                  </CardHeader>
                  <CardBody>
                    <CardText className="font-size-16 font-weight-semibold">
                      {pragmatic.total_win_bet_count.toLocaleString()}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={2} className="m-2">
                <Card
                  className="border-2 border-secondary text-secondary"
                  style={cardstyle}
                >
                  <CardHeader
                    className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                    style={cardHeader}
                  >
                    Total Bets Winning Amount
                  </CardHeader>
                  <CardBody>
                    <CardText className="font-size-16 font-weight-semibold">
                      {formatAmount(pragmatic.total_win_bet_amount)}
                      <span style={currencyStyle}> {currency}</span>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={2} className="m-2">
                <Card
                  className="border-2 border-primary text-primary"
                  style={cardstyle}
                >
                  <CardHeader
                    className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                    style={cardHeader}
                  >
                    Profit
                  </CardHeader>
                  <CardBody>
                    <CardText className="font-size-16 font-weight-semibold">
                      {formatAmount(pragmatic.profit)}
                      <span style={currencyStyle}> {currency}</span>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={2} className="m-2">
                <Card
                  className="border-2 border-info text-info"
                  style={cardstyle}
                >
                  <CardHeader
                    className="bg-transparent text-uppercase font-weight-semibold font-size-16"
                    style={cardHeader}
                  >
                    RTP
                  </CardHeader>
                  <CardBody>
                    <CardText className="font-size-16 font-weight-semibold">
                      {formatAmount(pragmatic.RTP)}
                      <span style={currencyStyle}> %</span>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Collapse>
      </Card>
    )
  )
}
